import { render, staticRenderFns } from "./CrisisScenarios.vue?vue&type=template&id=3a940719&scoped=true"
import script from "./CrisisScenarios.vue?vue&type=script&lang=js"
export * from "./CrisisScenarios.vue?vue&type=script&lang=js"
import style0 from "./CrisisScenarios.vue?vue&type=style&index=0&id=3a940719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a940719",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
